import React, { useEffect, useState } from "react";
import { Table, Spinner } from "reactstrap";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const Enach = () => {
  const { cid, lid } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

 const formatDateTime = (dateTime) => {
  if (!dateTime) return "N/A";
  try {
    const date = new Date(dateTime);
    const pad = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // months are 0-indexed
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch {
    return "Invalid Date";
  }
};


  const formatCurrency = (amount) =>
    amount ? `₹${Number(amount).toLocaleString("en-IN")}` : "N/A";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `${URL.ENACH_LIST_NEW}?customerId=${cid}&leadId=${lid}`
        );
        setData(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching ENACH data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cid, lid]);

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div>
      <Table className="align-items-center table-flush" responsive bordered striped>
        <thead className="thead-light">
          <tr>
            <th>Order ID</th>
            <th>Order Status</th>
            <th>Order Date</th>
            <th>Method</th>
            <th>Token ID</th>
            <th>Token Status</th>
            <th>Max Amount</th>
            <th>Token Date</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>{item.orderId || "N/A"}</td>
                <td>{item.orderStatus || "N/A"}</td>
                <td>{formatDateTime(item.orderUpdateDate)}</td>
                <td>{item.source || "N/A"}</td>
                <td>{item.token || "N/A"}</td>
                <td>{item.tokenStatus || "N/A"}</td>
                <td>{formatCurrency(item.maxAmount)}</td>
                <td>{formatDateTime(item.tokenUpdateDate)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No Razorpay order info available.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default Enach;
